__turbopack_context__.v({
  "sticky-bar": "StickyBar-module-scss-module__bQBd4G__sticky-bar",
  "sticky-bar__body": "StickyBar-module-scss-module__bQBd4G__sticky-bar__body",
  "sticky-bar__button": "StickyBar-module-scss-module__bQBd4G__sticky-bar__button",
  "sticky-bar__copy": "StickyBar-module-scss-module__bQBd4G__sticky-bar__copy",
  "sticky-bar__heading": "StickyBar-module-scss-module__bQBd4G__sticky-bar__heading",
  "sticky-bar__image": "StickyBar-module-scss-module__bQBd4G__sticky-bar__image",
  "sticky-bar__inner": "StickyBar-module-scss-module__bQBd4G__sticky-bar__inner",
  "sticky-bar__picture": "StickyBar-module-scss-module__bQBd4G__sticky-bar__picture",
  "sticky-bg": "StickyBar-module-scss-module__bQBd4G__sticky-bg",
});
